import { PurchaseOrderImportPage } from "@/features/purchase-order/pages/PurchaseOrderImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-order/import")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["purchase_order.create"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: PurchaseOrderImportPage,
});
